export const getAllSpacesByProjectId = ([, projectId])=>(state)=>state.spaces.items[projectId];
export const getSpacesCreating = (state)=>state.spaces.creating;
export const spacesSelector = (state)=>Object.values(state.spaces.items);
export const getSpaceByIdSelector = (spaceId)=>({ spaces })=>spaces.items[spaceId];
export const selectSpaceFetchStatus = (spaceId)=>({ spaces })=>spaces.itemsFetchStatus[spaceId];
export const getCurrentSpaceSelector = ({ spaces })=>spaces.currentSpace;
export const isDeletingSelector = ({ spaces })=>spaces.deleting;
export const isEditingSelector = ({ spaces })=>spaces.isEditing;
/**
 * @function isEditSelector
 * @param spaces
 * @return boolean
 */ export const isEditSelector = ({ spaces })=>spaces.edit;
/**
 * @function spacesStateSelector
 * @param state
 * @return SpaceState
 */ export const spacesStateSelector = (state)=>state.spaces;
const getSpacesByProjectId = (spaces, [, projectId])=>Object.values(spaces).filter((s)=>s.project === projectId);
export const spacesByProjectIdSelector = (projectId)=>(state)=>getSpacesByProjectId(spacesSelector(state), projectId);
